import { isValidBusinessObject, ValidBusinessObject } from '@iotv/iotv-v3-types'

export type ValidEntityGroup = ValidBusinessObject & { type: 'Group'; supportedType: string }
export const isValidEntityGroup = (x: any): x is ValidEntityGroup => isValidBusinessObject(x) && x.type === 'Group' && typeof x.supportedType === 'string'
